import { Component, inject, input } from '@angular/core';
import { AlertService } from 'app/shared/services/alert/alert.service';
import { ModalService } from 'app/shared/services/modal/modal.service';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'info-modal',
  standalone: true,
  imports: [DialogModule, ButtonModule],
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.css'
})
export class InfoModalComponent {
  private readonly modalService = inject(ModalService);
  private readonly toast = inject(AlertService);

  modalId = input('confirm-modal');

  /** Personalización */
  iconSrc = input('alert-icon.svg');
  confirmLabel = input('Aceptar');

  /** Two-way para PrimeNG [(visible)] usando el servicio */
  get isVisible(): boolean {
    return this.modalService.isVisible(this.modalId())();
  }

  set isVisible(v: boolean) {
    if (!v) this.modalService.closeModal(this.modalId());
  }

  /** Acceso a los datos del modal almacenados en el servicio */
  modalData = () => this.modalService.getData(this.modalId())();

  closeModal(): void {
    this.modalService.closeModal(this.modalId());
  }

  confirmAction(): void {
    const data = this.modalData();
    if (data?.onConfirm) {
      data.onConfirm();
    } else {
      this.toast.showAlertSuccess('¡Listo!', 'Acción confirmada correctamente');
    }
    this.modalService.closeModal(this.modalId());
  }
}
